import React, { useState, useRef, useEffect } from "react";
import "./A1MultipleSelectDropDown.css";

const A1MultipleSelectDropDown = ({
  item,
  addMessages,
  setisSubscriber,
  showMaximumChat,
  setIsShowMaximumChat,
  setErrors,
  index,
  scrollToBottom,
}) => {
  const parseData = () => {
    try {
      const textData = typeof item?.text === "string" ? JSON.parse(item.text) : item?.text;
      return textData?.data || [];
    } catch (e) {
      console.error("Error parsing item.text:", e);
      return [];
    }
  };

  const dataArray = parseData();
  const autoSelected = dataArray.filter((opt) => opt.autoSelected).map((opt) => opt.value);
  
  const [selectedValues, setSelectedValues] = useState(autoSelected);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelectedValues(autoSelected);
    // Use setTimeout to ensure parent state is ready
    setTimeout(() => {
      if (autoSelected.length >= 1) {
        setErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          updatedErrors[index] = { 
            key1: autoSelected, 
            displayName: autoSelected.join(", ") 
          };
          console.log("🔄 Updated Errors inside useEffect:", updatedErrors);
          return updatedErrors;
        });
      } else {
        setErrors((prev) => ({ ...prev, [index]: true }));
      }
    }, 0);
  }, [item, index, setErrors, autoSelected.length]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
    if (!isOpen && scrollToBottom) {
      setTimeout(() => scrollToBottom(), 100);
    }
  };

  const handleRemove = (valueToRemove) => {
    const updated = selectedValues.filter((val) => val !== valueToRemove);
    setSelectedValues(updated);
    
    if (updated.length >= 1) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[index] = { 
          key1: updated, 
          displayName: updated.join(", ") 
        };
        console.log("🔄 Updated Errors on Remove:", updatedErrors);
        return updatedErrors;
      });
    } else {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[index] = false;
        console.log("❌ Error set on Remove (empty):", updatedErrors);
        return updatedErrors;
      });
    }
  };

  const handleAdd = (valueToAdd) => {
    if (!selectedValues.includes(valueToAdd)) {
      const updated = [...selectedValues, valueToAdd];
      setSelectedValues(updated);
      
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        updatedErrors[index] = { 
          key1: updated, 
          displayName: updated.join(", ") 
        };
        console.log("🔄 Updated Errors on Add:", updatedErrors);
        return updatedErrors;
      });
    }
  };

  const availableOptions = dataArray.filter(
    (opt) => !opt.disabled && !selectedValues.includes(opt.value)
  );

  const filteredOptions = availableOptions.filter((opt) =>
    opt.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="a1-multiselect-wrapper action-tab" ref={dropdownRef}>
      <div
        className="a1-multiselect-input"
        onClick={handleToggleDropdown}
      >
        {selectedValues.length > 0 ? (
          <div className="a1-multiselect-chips">
            {selectedValues.map((value, idx) => (
              <div key={idx} className="a1-chip">
                <span className="a1-chip-text">{value}</span>
                <span
                  className="a1-chip-cross action-tab"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemove(value);
                  }}
                >
                  ×
                </span>
              </div>
            ))}
          </div>
        ) : (
          <span className="a1-multiselect-placeholder">
            Select options...
          </span>
        )}
        <span className="a1-multiselect-arrow">{isOpen ? "▲" : "▼"}</span>
      </div>

      {isOpen && (
        <div className="a1-multiselect-dropdown">
          <input
            type="text"
            className="a1-multiselect-search"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onClick={(e) => e.stopPropagation()}
          />
          <div className="a1-multiselect-options">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, idx) => (
                <div
                  key={idx}
                  className="a1-multiselect-option"
                  onClick={() => handleAdd(option.value)}
                >
                  {option.name}
                </div>
              ))
            ) : (
              <div className="a1-multiselect-no-options">No options available</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default A1MultipleSelectDropDown;
